import React, { useState, useEffect } from "react";
import Header from "../../../components/Header";

import NavigationComponent from "../../../components/NavigationComponent";
import { getMasterSubMenu, getSectionCMS } from "../../../adminApi/mastermenu";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import FadeLoader from "react-spinners/FadeLoader";
import axios from "axios";
import ColorDropdowns from "../../../components/ColorDropdown/ColorDropdowns";
import { updateHeaderTitleFunc } from "../../../adminApi/updateHeaderTitle";
import Editor from "react-simple-wysiwyg";
import "./cmsBirthday.css";
function CmsSchedule() {
  const { menuId } = useParams();
  const token = localStorage.getItem("access_token");
  const [activeAccordion, setActiveAccordion] = useState(0);
  const [subMenu, setSubMenu] = useState([]);
  const [scheduleId, setScheduleId] = useState();
  const [sectionData, setSectionData] = useState([]);
  const [formData, setFormData] = useState({});
  const [images, setImages] = useState([]);
  const [partyDescription, setPartyDescription] = useState();
  const [showHeaderLoader, setShowHeaderLoader] = useState(false);
  const [activeAccordionIndex, setActiveAccordianIndex] = useState(0);
  const [activeAccordianId, setActiveAccordianId] = useState();
  const [partyHeaderDesc, setPartyHeaderDesc] = useState();
  const [quoteDesc, setQuoteDesc] = useState();
  const [basicPayment, setBasicPayment] = useState();
  const [inclusivePayment, setInclusivePayment] = useState();
  const [ultimatePayment, setUltimatePayment] = useState();
  const [partyPageFooterTitle, setPartyPageFooterTitle] = useState();
  const [partyPageEmail, setpartyPageEmail] = useState();
  const [html, setHtml] = useState(`<div className="shortText">
  <p className="para">
    The All Inclusive package includes 60 minutes of instructor-led
    fun in the gym and 30 minutes in the party room for food,
    refreshments, and cake. 12 children included, $35/additional
    child with a maximum of 25 children.
  </p>
  <ul className="para">
    <li>
      1. Plain colored paper goods of your choice for all guests
    </li>
    <li>2.Utensils</li>
    <li>3.Tablecloths</li>
    <li>4.Gymtime Balloons (white with a Gymtime logo) </li>
    <li>5.Birthday Banner</li>
    <li>6.Melissa & Doug Party Favors</li>
    <li>7.Pizza & Water for children</li>
    <li>
      8.Cake from BTW Bakery (round cake completely covered in
      sprinkles)
    </li>
  </ul>
</div>`);
  const [allInclusive, setAllInclusive] = useState(`<div className="shortText">
<p className="para">
  The All Inclusive package includes 60 minutes of instructor-led
  fun in the gym and 30 minutes in the party room for food,
  refreshments, and cake. 12 children included, $35/additional
  child with a maximum of 25 children.
</p>
<ul className="para">
  <li>
    1. Plain colored paper goods of your choice for all guests
  </li>
  <li>2.Utensils</li>
  <li>3.Tablecloths</li>
  <li>4.Gymtime Balloons (white with a Gymtime logo) </li>
  <li>5.Birthday Banner</li>
  <li>6.Melissa & Doug Party Favors</li>
  <li>7.Pizza & Water for children</li>
  <li>
    8.Cake from BTW Bakery (round cake completely covered in
    sprinkles)
  </li>
</ul>
</div>`);
  const [ultimate, setUltimate] = useState(`<div className="shortText">
<p className="para">
  The All Inclusive package includes 60 minutes of instructor-led
  fun in the gym and 30 minutes in the party room for food,
  refreshments, and cake. 12 children included, $35/additional
  child with a maximum of 25 children.
</p>
<ul className="para">
  <li>
    1. Plain colored paper goods of your choice for all guests
  </li>
  <li>2.Utensils</li>
  <li>3.Tablecloths</li>
  <li>4.Gymtime Balloons (white with a Gymtime logo) </li>
  <li>5.Birthday Banner</li>
  <li>6.Melissa & Doug Party Favors</li>
  <li>7.Pizza & Water for children</li>
  <li>
    8.Cake from BTW Bakery (round cake completely covered in
    sprinkles)
  </li>
</ul>
</div>`);
  const accordionHandler = async (index, id) => {
    setScheduleId(id);
    setActiveAccordion(index);
    setShowHeaderLoader(true);
    const section = await getSectionCMS(token, id);
    setSectionData(section);
    setShowHeaderLoader(false);
  };
  useEffect(() => {
    getMasterAboutMenuData();
  }, [images]);

  const getMasterAboutMenuData = async () => {
    const response = await getMasterSubMenu(token, menuId);
    setSubMenu(response);
    const section = await getSectionCMS(
      token,
      scheduleId ? (scheduleId !== undefined ? scheduleId : "174") : "174"
    );
    setSectionData(section);
    section?.map((item) => {
      item?.section_name === "Let's Party" &&
        setPartyDescription(item?.descriptionSection?.description);
      item?.section_name === "Playtime" &&
        setQuoteDesc(item?.descriptionSection?.description);
      item?.section_name === "Package 1" &&
        setHtml(item?.descriptionSection?.description);
      item?.section_name === "Package 2" &&
        setAllInclusive(item?.descriptionSection?.description);
      item?.section_name === "Package 3" &&
        setUltimate(item?.descriptionSection?.description);
      item?.section_name === "Party Page Description" &&
        setPartyHeaderDesc(item?.descriptionSection?.description);

      item?.section_name === "Package 1" &&
        setBasicPayment(item?.price_package);
      item?.section_name === "Package 2" &&
        setInclusivePayment(item?.price_package);
      item?.section_name === "Package 3" &&
        setUltimatePayment(item?.price_package);
      item?.section_name === "Party Page Footer 1" &&
        setPartyPageFooterTitle(item?.descriptionSection?.description);
      item?.section_name === "Party Page Footer 2" &&
        setpartyPageEmail(item?.descriptionSection?.description);
    });
  };

  const handleFileChange = async (e, id) => {
    const sectionId = parseInt(id, 10);
    e.preventDefault();
    try {
      const selectedFiles = e.target.files;
      if (selectedFiles && selectedFiles?.length > 0) {
        const file = selectedFiles[0];
        const reader = new FileReader();

        // Create a Promise to wait for the FileReader to load
        const loadPromise = new Promise((resolve) => {
          reader.onloadend = () => {
            resolve();
          };
        });

        // Start loading the file
        reader.readAsDataURL(file);

        // Wait for the FileReader to finish loading
        await loadPromise;

        const img = new Image();
        img.src = reader.result;

        img.onload = async () => {
          // Set the desired height and width
          const desiredHeight = 780;
          const desiredWidth = 1920;

          // Create a canvas element to draw the image with the new dimensions
          const canvas = document.createElement("canvas");
          canvas.height = desiredHeight;
          canvas.width = desiredWidth;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          // Convert the canvas content to a data URL
          const convertedFile = {
            image: canvas.toDataURL("image/jpeg"), // Use 'image/jpeg' for JPEG format
          };

          const convertedFileName = {
            name: file.name,
          };

          setImages([convertedFile]);
          setFormData({ ...formData, file: convertedFileName });

          const postData = {
            image: convertedFile.image,
            section_id: sectionId,
          };

          // Perform the API call here
          const token = localStorage.getItem("access_token");
          try {
            const response = await axios.post(
              process.env.REACT_APP_BASE_URL + `/admin/imageupload-cms`,
              postData,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            if (response?.status === 200 || response?.status === 201) {
              toast.success("Image uploaded successfully.");
              await accordionHandler(activeAccordionIndex, activeAccordianId);
            }
          } catch (error) {
            return error;
          }
        };
      }
    } catch (error) {
      return error;
    }
  };

  const handleFileChange1 = async (e, id) => {
    const sectionId = parseInt(id, 10);
    e.preventDefault();

    try {
      const selectedFiles = e.target.files;
      if (selectedFiles && selectedFiles?.length > 0) {
        const file = selectedFiles[0];
        const reader = new FileReader();

        // Create a Promise to wait for the FileReader to load
        const loadPromise = new Promise((resolve) => {
          reader.onloadend = () => {
            resolve();
          };
        });

        // Start loading the file
        reader.readAsDataURL(file);

        // Wait for the FileReader to finish loading
        await loadPromise;

        const img = new Image();
        img.src = reader.result;

        img.onload = async () => {
          // Set the desired height and width
          const desiredHeight = 412;
          const desiredWidth = 550;

          // Create a canvas element to draw the image with the new dimensions
          const canvas = document.createElement("canvas");
          canvas.height = desiredHeight;
          canvas.width = desiredWidth;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          // Convert the canvas content to a data URL
          const resizedImage = canvas.toDataURL("image/jpeg"); // You can also use 'image/png' for PNG format

          const postData = {
            image: resizedImage,
            section_id: sectionId,
          };

          // Perform the API call here
          const token = localStorage.getItem("access_token");
          try {
            const response = await axios.post(
              process.env.REACT_APP_BASE_URL + `/admin/imageupload-cms`,
              postData,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            if (response?.status === 200 || response?.status === 201) {
              toast.success("Image uploaded successfully.");
              await accordionHandler(activeAccordionIndex, activeAccordianId);
            }
          } catch (error) {
            return error;
          }
        };
      }
    } catch (error) {
      return error;
    }
  };

  const descriptionHandler = async (id, desc, amount, price) => {
    try {
      // if (partyDescription?.length < 150) {
      //   toast.error("Description must be atleast 150 characters.");
      //   return;
      // }
      // if (partyDescription?.length > 350) {
      //   toast.error("Description must not be more than 350 characters.");
      //   return;
      // }
      const postData = {
        description: desc !== null ? desc : partyDescription,
        section_id: id !== null ? id : sectionData[1]?.id,
      };
      //integrating the description API for home
      const token = localStorage.getItem("access_token");
      const response = await axios.post(
        process.env.REACT_APP_BASE_URL + `/admin/description-cms`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.status === 201 || response?.status === 200) {
        toast.success("Description added successfully.");
        if (amount === "amount") {
          const postData = {
            price: parseInt(price),
            id: parseInt(id),
            sub_menu_id: 174,
          };
          const response = await axios.post(
            process.env.REACT_APP_BASE_URL + `/admin/update_birthday`,
            postData,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response?.status === 200 || response?.status === 201) {
            toast.success("New description and amount updated successfully.");
          }
        }
      }
    } catch (error) {
      toast.error("Please add description");
      console.error("error", error);
    }
  };

  return (
    <>
      <div className="container--component">
        <div className="container--grid">
          <NavigationComponent />
          <div className="Adminpage">
            <Header
              title="Birthday & Events"
              subTitle="(Manage Birthday & Events)"
            />
            <section class="Adminpage__section">
              <div class="Adminpage__body">
                <div class="accordion">
                  {subMenu?.map((val, index) => {
                    return (
                      <div
                        className={`accordion__card ${
                          activeAccordion === index ? "active" : ""
                        }`}
                        style={{ cursor: "pointer" }}
                        key={index}
                      >
                        <div
                          class="accordion__card__header"
                          onClick={() => {
                            accordionHandler(index, val?.id);
                            setActiveAccordianId(val?.id);
                            setActiveAccordianIndex(index);
                          }}
                        >
                          <h2 class="title">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.4615 3.7712C7.72183 3.51085 7.72183 3.08874 7.4615 2.82839L5.57588 0.942771C5.53707 0.903964 5.49647 0.868044 5.45433 0.835024C5.00181 0.480349 4.37288 0.459313 3.89943 0.771917C3.82549 0.820731 3.75535 0.877684 3.69026 0.942771L1.80464 2.82839C1.54429 3.08874 1.54429 3.51085 1.80464 3.7712C2.06499 4.03155 2.4871 4.03155 2.74745 3.7712L3.99992 2.51872V12C3.99992 12.3682 4.2984 12.6666 4.66659 12.6666C5.03478 12.6666 5.33325 12.3682 5.33325 12V2.58576L6.51869 3.7712C6.77903 4.03154 7.20117 4.03154 7.4615 3.7712Z"
                                fill="white"
                              />
                              <path
                                d="M8.47162 12.2288C8.21128 12.4892 8.21128 12.9112 8.47162 13.1716L10.3572 15.0572C10.4224 15.1223 10.4925 15.1793 10.5664 15.2281C11.084 15.5698 11.7872 15.5128 12.2429 15.0572L14.1285 13.1716C14.3888 12.9112 14.3888 12.4892 14.1285 12.2288C13.8682 11.9684 13.446 11.9684 13.1857 12.2288L12.0002 13.4142V4.00004C12.0002 3.63185 11.7018 3.33337 11.3336 3.33337C10.9654 3.33337 10.6669 3.63185 10.6669 4.00004V13.4812L9.41442 12.2288C9.15408 11.9684 8.73195 11.9684 8.47162 12.2288Z"
                                fill="white"
                              />
                            </svg>
                            {val?.sub_menu_name}
                          </h2>
                          <div class="actions">
                            <button class="actions__btn accordionToggleBtn">
                              <svg
                                width="14"
                                height="8"
                                viewBox="0 0 14 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M0.707131 7.28933C0.316631 6.89883 0.316631 6.26563 0.707131 5.87513L5.59933 0.987686C6.38053 0.207286 7.64633 0.207595 8.42713 0.988375L13.3175 5.87873C13.708 6.26923 13.708 6.90243 13.3175 7.29293C12.9269 7.68353 12.2938 7.68353 11.9032 7.29293L7.71763 3.10733C7.32703 2.71683 6.69393 2.71683 6.30343 3.10733L2.12133 7.28933C1.73083 7.67983 1.09763 7.67983 0.707131 7.28933Z"
                                  fill="white"
                                />
                              </svg>
                            </button>
                            <button class="actions__btn">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H9M15 5H17C18.1046 5 19 5.89543 19 7V9"
                                  stroke="white"
                                  strokeWidth="2.33333"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M14.9015 20.3343L12.7148 20.7716L13.1521 18.585C13.1909 18.3914 13.286 18.2136 13.4256 18.074L17.4995 14L19.4995 12L21.4864 13.9869L19.4864 15.9869L15.4125 20.0608C15.2729 20.2004 15.0951 20.2956 14.9015 20.3343Z"
                                  stroke="white"
                                  strokeWidth="2.33333"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                                  stroke="white"
                                  strokeWidth="2.33333"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                        <div class="accordion__card__body">
                          <h3 class="title">
                            Note: Compress back after completion of activity
                          </h3>
                          <div class="commonList">
                            <div class="commonList__row">
                              {sectionData?.map(
                                (item) =>
                                  item?.section_name === "Header" && (
                                    <div class="commonList__row__col">
                                      <h4 class="label">Header Image:</h4>
                                      <div class="cardbox">
                                        <div class="browseBox">
                                          <div class="browseFile">
                                            <div class="browseFile__icon">
                                              <svg
                                                width="33"
                                                height="33"
                                                viewBox="0 0 33 33"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                              >
                                                <rect
                                                  x="0.180664"
                                                  width="32.53"
                                                  height="32.53"
                                                  fill="url(#pattern0)"
                                                />
                                                <defs>
                                                  <pattern
                                                    id="pattern0"
                                                    patternContentUnits="objectBoundingBox"
                                                    width="1"
                                                    height="1"
                                                  >
                                                    <image xlinkHref="data:image/png;base64,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" />
                                                  </pattern>
                                                </defs>
                                              </svg>
                                            </div>
                                            <h4 class="browseFile__text">
                                              Drag files to upload
                                            </h4>
                                            <p class="browseFile__ortext">or</p>
                                            <input
                                              class="hiddenInput"
                                              id="BrowseFiles1"
                                              type="file"
                                              onChange={(e) =>
                                                handleFileChange(e, item?.id)
                                              }
                                            />
                                            <label
                                              for="BrowseFiles1"
                                              class="browseBtn"
                                            >
                                              Browse Files
                                            </label>
                                            <div class="browseFileData">
                                              <p class="browseFileData__text">
                                                Max File Size:{" "}
                                                <strong>10 MB</strong>
                                              </p>
                                              <p class="browseFileData__text">
                                                Supported file type:{" "}
                                                <strong>JPG,PNG,SVG</strong>
                                              </p>
                                            </div>
                                            <div>
                                              {showHeaderLoader === true ? (
                                                <div className="loader_container">
                                                  <FadeLoader
                                                    color="#5497C7"
                                                    height={21}
                                                    margin={1}
                                                  />
                                                </div>
                                              ) : (
                                                <img
                                                  src={
                                                    item?.imageSection?.image
                                                  }
                                                  alt=""
                                                  className="prevImage"
                                                />
                                              )}
                                            </div>
                                          </div>
                                          <div class="adminbutton__group">
                                            {/* <button class="adminbtn adminbtn-blueOutline">
                                          Cancel
                                        </button> */}
                                            {/* <button class="adminbtn adminbtn-primary">
                                                Save
                                              </button> */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )
                              )}
                              {sectionData?.map(
                                (item) =>
                                  item?.section_name === "Let's Party" && (
                                    <div class="commonList__row__col">
                                      <h4 class="label">
                                        {" "}
                                        {val?.sub_menu_name} Image:
                                      </h4>
                                      <div class="cardbox">
                                        <div class="browseBox">
                                          <div class="browseFile">
                                            <div class="browseFile__icon">
                                              <svg
                                                width="33"
                                                height="33"
                                                viewBox="0 0 33 33"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                              >
                                                <rect
                                                  x="0.180664"
                                                  width="32.53"
                                                  height="32.53"
                                                  fill="url(#pattern0)"
                                                />
                                                <defs>
                                                  <pattern
                                                    id="pattern0"
                                                    patternContentUnits="objectBoundingBox"
                                                    width="1"
                                                    height="1"
                                                  >
                                                    <use
                                                      xlinkHref="#image0_0_11529"
                                                      transform="scale(0.01)"
                                                    />
                                                  </pattern>
                                                  <image
                                                    id="image0_0_11529"
                                                    width="100"
                                                    height="100"
                                                    xlinkHref="data:image/png;base64,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"
                                                  />
                                                </defs>
                                              </svg>
                                            </div>
                                            <h4 class="browseFile__text">
                                              Drag files to upload
                                            </h4>
                                            <p class="browseFile__ortext">or</p>
                                            <input
                                              class="hiddenInput"
                                              id="BrowseFiles2"
                                              type="file"
                                              onChange={(e) =>
                                                handleFileChange1(e, item?.id)
                                              }
                                            />
                                            <label
                                              for="BrowseFiles2"
                                              class="browseBtn"
                                            >
                                              Browse Files
                                            </label>
                                            <div class="browseFileData">
                                              <p class="browseFileData__text">
                                                Max File Size:{" "}
                                                <strong>10 MB</strong>
                                              </p>
                                              <p class="browseFileData__text">
                                                Supported file type:{" "}
                                                <strong>JPG,PNG,SVG</strong>
                                              </p>
                                            </div>
                                            <div>
                                              {showHeaderLoader === true ? (
                                                <div className="loader_container">
                                                  <FadeLoader
                                                    color="#5497C7"
                                                    height={21}
                                                    margin={1}
                                                  />
                                                </div>
                                              ) : (
                                                <img
                                                  src={
                                                    item?.imageSection?.image
                                                  }
                                                  alt=""
                                                  className="prevImage"
                                                />
                                              )}
                                            </div>
                                          </div>
                                          <div class="adminbutton__group">
                                            {/* <button class="adminbtn adminbtn-blueOutline">
                                        Cancel
                                      </button> */}
                                            {/* <button class="adminbtn adminbtn-primary">
                                              Save
                                            </button> */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )
                              )}

                              {sectionData?.map(
                                (item) =>
                                  item?.section_name === "Playtime" && (
                                    <div class="commonList__row__col">
                                      <h4 class="label">
                                        {item?.section_name} Image:
                                      </h4>
                                      <div class="cardbox">
                                        <div class="browseBox">
                                          <div class="browseFile">
                                            <div class="browseFile__icon">
                                              <svg
                                                width="33"
                                                height="33"
                                                viewBox="0 0 33 33"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                              >
                                                <rect
                                                  x="0.180664"
                                                  width="32.53"
                                                  height="32.53"
                                                  fill="url(#pattern0)"
                                                />
                                                <defs>
                                                  <pattern
                                                    id="pattern0"
                                                    patternContentUnits="objectBoundingBox"
                                                    width="1"
                                                    height="1"
                                                  >
                                                    <image xlinkHref="data:image/png;base64,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" />
                                                  </pattern>
                                                </defs>
                                              </svg>
                                            </div>
                                            <h4 class="browseFile__text">
                                              Drag files to upload
                                            </h4>
                                            <p class="browseFile__ortext">or</p>
                                            <input
                                              class="hiddenInput"
                                              id="BrowseFiles4"
                                              type="file"
                                              onChange={(e) =>
                                                handleFileChange1(e, item?.id)
                                              }
                                            />
                                            <label
                                              for="BrowseFiles4"
                                              class="browseBtn"
                                            >
                                              Browse Files
                                            </label>
                                            <div class="browseFileData">
                                              <p class="browseFileData__text">
                                                Max File Size:{" "}
                                                <strong>10 MB</strong>
                                              </p>
                                              <p class="browseFileData__text">
                                                Supported file type:{" "}
                                                <strong>JPG,PNG,SVG</strong>
                                              </p>
                                            </div>
                                            <div>
                                              {showHeaderLoader === true ? (
                                                <div className="loader_container">
                                                  <FadeLoader
                                                    color="#5497C7"
                                                    height={21}
                                                    margin={1}
                                                  />
                                                </div>
                                              ) : (
                                                <img
                                                  src={
                                                    item?.imageSection?.image
                                                  }
                                                  alt=""
                                                  className="prevImage"
                                                />
                                              )}
                                            </div>
                                          </div>
                                          <div class="adminbutton__group">
                                            {/* <button class="adminbtn adminbtn-blueOutline">
                                          Cancel
                                        </button> */}
                                            {/* <button class="adminbtn adminbtn-primary">
                                                Save
                                              </button> */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )
                              )}
                            </div>
                            <div class="commonList__row">
                              <h4 class="label">
                                {" "}
                                {val?.sub_menu_name} Description:
                              </h4>
                              <div class="cardbox">
                                <div class="adminform__group">
                                  <textarea
                                    class="adminform__textarea"
                                    placeholder="write the contents here!"
                                    value={partyDescription}
                                    onChange={(e) =>
                                      setPartyDescription(e.target.value)
                                    }
                                  ></textarea>
                                </div>
                                <div class="adminbutton__group">
                                  {/* <button class="admibtn admibtn-blueOutline">
                                    Cancel
                                  </button> */}
                                  <button
                                    class="admibtn admibtn-primary"
                                    onClick={() =>
                                      descriptionHandler(null, partyDescription)
                                    }
                                  >
                                    Save
                                  </button>
                                </div>
                              </div>
                            </div>

                            {sectionData?.map(
                              (item) =>
                                item?.section_name === "Playtime" && (
                                  <div class="commonList__row">
                                    <h4 class="label">
                                      {" "}
                                      {item?.section_name} Description:
                                    </h4>
                                    <div class="cardbox">
                                      <div class="adminform__group">
                                        <textarea
                                          class="adminform__textarea"
                                          placeholder="write the contents here!"
                                          value={quoteDesc}
                                          onChange={(e) =>
                                            setQuoteDesc(e.target.value)
                                          }
                                        ></textarea>
                                      </div>
                                      <div class="adminbutton__group">
                                        <button
                                          class="admibtn admibtn-primary"
                                          onClick={() =>
                                            descriptionHandler(
                                              item?.id,
                                              quoteDesc
                                            )
                                          }
                                        >
                                          Save
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )
                            )}

                            {/* ================================pARTY PAGE CMS STARTS=================== */}
                            {sectionData?.map(
                              (item) =>
                                item?.section_name === "Party Page Header" && (
                                  <div className="commonList__row">
                                    <div class="commonList__row__col">
                                      <h4 class="label">
                                        {item?.section_name}:
                                      </h4>
                                      <div class="cardbox">
                                        <div class="browseBox">
                                          <div class="browseFile">
                                            <div class="browseFile__icon">
                                              <svg
                                                width="33"
                                                height="33"
                                                viewBox="0 0 33 33"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                              >
                                                <rect
                                                  x="0.180664"
                                                  width="32.53"
                                                  height="32.53"
                                                  fill="url(#pattern0)"
                                                />
                                                <defs>
                                                  <pattern
                                                    id="pattern0"
                                                    patternContentUnits="objectBoundingBox"
                                                    width="1"
                                                    height="1"
                                                  >
                                                    <image xlinkHref="data:image/png;base64,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" />
                                                  </pattern>
                                                </defs>
                                              </svg>
                                            </div>
                                            <h4 class="browseFile__text">
                                              Drag files to upload
                                            </h4>
                                            <p class="browseFile__ortext">or</p>
                                            <input
                                              class="hiddenInput"
                                              id="BrowseFiles-31"
                                              type="file"
                                              onChange={(e) =>
                                                handleFileChange(e, item?.id)
                                              }
                                            />
                                            <label
                                              for="BrowseFiles-31"
                                              class="browseBtn"
                                            >
                                              Browse Files
                                            </label>
                                            <div class="browseFileData">
                                              <p class="browseFileData__text">
                                                Max File Size:{" "}
                                                <strong>10 MB</strong>
                                              </p>
                                              <p class="browseFileData__text">
                                                Supported file type:{" "}
                                                <strong>JPG,PNG,SVG</strong>
                                              </p>
                                            </div>
                                            <div>
                                              {showHeaderLoader === true ? (
                                                <div className="loader_container">
                                                  <FadeLoader
                                                    color="#5497C7"
                                                    height={21}
                                                    margin={1}
                                                  />
                                                </div>
                                              ) : (
                                                <img
                                                  src={
                                                    item?.imageSection?.image
                                                  }
                                                  alt=""
                                                  className="prevImage"
                                                />
                                              )}
                                            </div>
                                          </div>
                                          <div class="adminbutton__group">
                                            {/* <button class="adminbtn adminbtn-blueOutline">
                                            Cancel
                                          </button> */}
                                            {/* <button class="adminbtn adminbtn-primary">
                                                  Save
                                                </button> */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                            )}

                            {sectionData?.map(
                              (item) =>
                                item?.section_name ===
                                  "Party Page Description" && (
                                  <div class="commonList__row">
                                    <h4 class="label">
                                      {" "}
                                      {item?.section_name} :
                                    </h4>
                                    <div class="cardbox">
                                      <div class="adminform__group">
                                        <textarea
                                          class="adminform__textarea"
                                          placeholder="write the contents here!"
                                          value={partyHeaderDesc}
                                          onChange={(e) =>
                                            setPartyHeaderDesc(e.target.value)
                                          }
                                        ></textarea>
                                      </div>
                                      <div class="adminbutton__group">
                                        <button
                                          class="admibtn admibtn-primary"
                                          onClick={() =>
                                            descriptionHandler(
                                              item?.id,
                                              partyHeaderDesc
                                            )
                                          }
                                        >
                                          Save
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )
                            )}

                            <div className="cms_birthday_packages">
                              <div className="commonList__row">
                                {sectionData?.map(
                                  (item) =>
                                    item?.section_name === "Package 1" && (
                                      <div>
                                        <Editor
                                          value={html}
                                          onChange={(e) =>
                                            setHtml(e.target.value)
                                          }
                                        />
                                        <div className="cms_birthday_amount_value">
                                          <input
                                            type="number"
                                            className="adminform__input"
                                            placeholder="Enter amount"
                                            value={basicPayment}
                                            onChange={(e) =>
                                              setBasicPayment(e.target.value)
                                            }
                                          />
                                        </div>
                                        <button
                                          class="admibtn admibtn-primary"
                                          onClick={() =>
                                            descriptionHandler(
                                              item?.id,
                                              html,
                                              "amount",
                                              basicPayment
                                            )
                                          }
                                        >
                                          Save
                                        </button>
                                      </div>
                                    )
                                )}
                              </div>
                              <div className="commonList__row">
                                {sectionData?.map(
                                  (item) =>
                                    item?.section_name === "Package 2" && (
                                      <div>
                                        <Editor
                                          value={allInclusive}
                                          onChange={(e) =>
                                            setAllInclusive(e.target.value)
                                          }
                                        />
                                        <div className="cms_birthday_amount_value">
                                          <input
                                            type="number"
                                            className="adminform__input"
                                            placeholder="Enter amount"
                                            value={inclusivePayment}
                                            onChange={(e) =>
                                              setInclusivePayment(
                                                e.target.value
                                              )
                                            }
                                          />
                                        </div>
                                        <button
                                          class="admibtn admibtn-primary"
                                          onClick={() =>
                                            descriptionHandler(
                                              item?.id,
                                              allInclusive,
                                              "amount",
                                              inclusivePayment
                                            )
                                          }
                                        >
                                          Save
                                        </button>
                                      </div>
                                    )
                                )}
                              </div>
                              <div className="commonList__row">
                                {sectionData?.map(
                                  (item) =>
                                    item?.section_name === "Package 3" && (
                                      <div>
                                        <Editor
                                          value={ultimate}
                                          onChange={(e) =>
                                            setUltimate(e.target.value)
                                          }
                                        />
                                        <div className="cms_birthday_amount_value">
                                          <input
                                            type="number"
                                            className="adminform__input"
                                            placeholder="Enter amount"
                                            value={ultimatePayment}
                                            onChange={(e) =>
                                              setUltimatePayment(e.target.value)
                                            }
                                          />
                                        </div>
                                        <button
                                          class="admibtn admibtn-primary"
                                          onClick={() =>
                                            descriptionHandler(
                                              item?.id,
                                              ultimate,
                                              "amount",
                                              ultimatePayment
                                            )
                                          }
                                        >
                                          Save
                                        </button>
                                      </div>
                                    )
                                )}
                              </div>
                            </div>

                            <div className="cms_birthday_anotella_email_edit_container">
                              <div className="heading_input_container">
                                {sectionData?.map(
                                  (item) =>
                                    item?.section_name ===
                                      "Party Page Footer 1" && (
                                      <div>
                                        <input
                                          type="text"
                                          placeholder="Enter heading"
                                          className="adminform__input"
                                          value={partyPageFooterTitle}
                                          onChange={(e) =>
                                            setPartyPageFooterTitle(
                                              e.target.value
                                            )
                                          }
                                        />
                                        <button
                                          className="admibtn-primary email_submit-btn"
                                          onClick={() =>
                                            descriptionHandler(
                                              item?.id,
                                              partyPageFooterTitle
                                            )
                                          }
                                        >
                                          Save
                                        </button>
                                      </div>
                                    )
                                )}
                                {sectionData?.map(
                                  (item) =>
                                    item?.section_name ===
                                      "Party Page Footer 2" && (
                                      <div>
                                        <input
                                          type="text"
                                          placeholder="Enter name with email"
                                          className="adminform__input"
                                          value={partyPageEmail}
                                          onChange={(e) =>
                                            setpartyPageEmail(e.target.value)
                                          }
                                        />
                                        <button
                                          className="admibtn-primary email_submit-btn"
                                          onClick={() =>
                                            descriptionHandler(
                                              item?.id,
                                              partyPageEmail
                                            )
                                          }
                                        >
                                          Save
                                        </button>
                                      </div>
                                    )
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default CmsSchedule;
